const authRoutes = {
  home: {
    path: '/'
  },
  login: {
    path: '/login'
  },
  register: {
    path: '/register'
  },
  registerSuccess: {
    path: '/register-success'
  },
  verifyEmail: {
    path: '/verify-email'
  },
  forgotPassword: {
    path: '/forgot-password'
  },
  verifyResetCode: {
    path: '/forgot-password/verify'
  },
  resetPassword: {
    path: '/reset-password'
  }
};

export default authRoutes;
